import React from 'react'
import { StaticQuery, Link } from "gatsby"
import styled from 'styled-components'
const translate = { 'recipe': 'Oppskrift', 'quiz': 'Quiz', 'standardQuiz': 'Quiz', 'article': 'Artikkel' }

const makeLinks = (content, onHover) => {
  const func = onHover ? onHover : () => { return }
  const { _type, title, slug, _id } = content

  return (
    <li key={_id} onMouseEnter={() => func(_id)}>
      <Link to={`/${_type}/${slug.current}`}>
        <h4>{title}</h4>
        <span>{translate[_type]}</span>
      </Link>
    </li>
  )
}

const ToCList = styled.ul`
  list-style-type: none;
  margin:0; padding:0;
  display: flex;
  flex-direction: column;
  height: 100%;

 h4 {
  font-size: calc(1em + .5vw);
 }
  li {
    margin: 4px 0px;
  }

  a {
    display: flex;
    flex-direction: column;
    text-decoration: none;
    color: black;

    &:hover {
      text-decoration: underline;
    }

    span {
      text-transform: uppercase;
      font-size: .7em;
    }
  }
    
`

export default ({ onHover, title }) => (
  <StaticQuery
    query={graphql`
    query TocQuery {
      sanitySiteSettings(_id: {eq: "siteSettings"}) {
        ...ContentQuery
      }
    }
  `}
    render={data => (
      <ToCList>       
        {data.sanitySiteSettings.toc.map(content => makeLinks(content, onHover))}
      </ToCList>
    )}
  />
)
